import { render, staticRenderFns } from "./BfTimePicker.vue?vue&type=template&id=545f45be&"
import script from "./BfTimePicker.vue?vue&type=script&lang=js&"
export * from "./BfTimePicker.vue?vue&type=script&lang=js&"
import style0 from "./BfTimePicker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports